export default "__VITE_ASSET__7c13c2e0__"